export const TABLEAU_EMBED_QUERY_PARAMS_DEFAULT =
    '?:embed=yes&:toolbar=no&:tabs=no&:subscriptions=no';
